import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../components/HeaderBread";
import CustomizedTable from "../../components/UI/CustomizedTable";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import Layout from "../../Layout";
import {
  addAPIlog,
  deleteApilogData,
  getUserAPIlogData,
  updateUserAPIlogData,
} from "../../utils/ApiCalls/Logs";
import UserAPILogEdit from "../../constants/UserAPILogEdit";
import DeletePop from "../../constants/ErrorPermissionModal";
const APILogs = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Log api",
      route: "/cmslog-api",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [active, setActive] = useState("listing");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const handleUpdate = async (id, values, title, location_id) => {
    let data = await updateUserAPIlogData(id, values);
    await getData(page);
  };
    const handleDelete = async (id, values, title, location_id) => {
    let data = await deleteApilogData(id, values);
    await getData(page);
  };
   const handleAdd = async (values) => {
    let data = await addAPIlog(values);

    await getData(page);
  };
  const columns = [
    {
      title: "Sl",
      width: 10,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: "Route",
      dataIndex: "route",
      key: "route",
      width: 50,
    },
    {
      title: "Status",
      dataIndex: "isLog",
      key: "isLog",
      width: 100,
      sorter: (a, b) => "",
      render: (item, record, index) => (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            checked={item}
            onChange={(value) => {
              try {
                handleUpdate(record.id, {
                  isLog: value.target.checked ? 1 : 0,
                });
              } catch (error) {
                dispatch({
                  type: "SET_LOADING",
                  loading: false,
                });
                dispatch({
                  type: "SET_ERROR_MESSAGE",
                  errMess: {
                    message: error.message || "Unknown error occurred",
                    type: "error",
                  },
                });
              }
            }}
            className="custom-control-input"
            id={"customSwitch1" + index}
          />
          <label
            className="custom-control-label"
            style={{}}
            htmlFor={"customSwitch1" + index}
          ></label>
        </div>
      ),
    },
     {
        title: "Action",
        key: "operation",
        width: 30,
        render: (text, record) => (
          <div className="table_action_btn">
        
            <DeletePop
              onConfirm={() =>
                handleDelete(record.id)
              }
            >
              <div>
                {" "}
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </div>
            </DeletePop>
          </div>
        ),
      },
  ];
  useEffect(() => {
    getData(page);
  }, [page, pageSize]);

  const getData = async (value) => {
    let args = { page: value, limit: pageSize };

    let data = await getUserAPIlogData(args);
    if (data.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Log api"}>
      <CustomHeaderTitle title={"Log api"} />
      <div>
        <div>
          <HeaderBread navigation={navigation} title={"Log api"}></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Log api List</h5>
                  <UserAPILogEdit handleAdd={handleAdd}/>
                </div>

                <div className="card-body">
                  <div className="table_holder">
                    <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      title={"Log api"}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default APILogs;
